import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment-timezone';
import './GuardiaPage.css';

const GuardiaPage = () => {
  const token = useSelector((state) => state.auth.token);
  const [serviciosCorral, setServiciosCorral] = useState([]);

  useEffect(() => {
    const fetchServiciosCorral = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/servicios/corral`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setServiciosCorral(response.data);
      } catch (error) {
        console.error('Error al obtener servicios en CORRAL:', error);
      }
    };

    fetchServiciosCorral();
  }, [token]);

  const handleActualizarCheckpoint = async (servicio) => {
    const nuevoCheckpoint = servicio.tipoService === 'LLEGADAS' ? 'SALIENDO' : 'ABORDAJE';
    try {
      await axios.put(
        `${API_BASE_URL}api/servicios/${servicio.noServicio}`,
        { checkpoint: nuevoCheckpoint },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Actualiza la lista local quitando el servicio actualizado
      setServiciosCorral((prev) =>
        prev.filter((s) => s.noServicio !== servicio.noServicio)
      );
    } catch (error) {
      console.error('Error al actualizar checkpoint:', error);
    }
  };

  const renderStatusProgress = (status) => {
    const estados = ['ASIGNADO', 'EN CURSO', 'CORRAL', 'CONCLUIDO'];
    const iconos = ['📋', '🚶‍♂️', '🧍‍♂️', '🏁'];
    const index = estados.indexOf(status);

    return (
      <div className="progress-circles">
        {estados.map((etapa, i) => (
          <div key={etapa} className="circle-container">
            <div className={`circle ${i <= index ? 'active' : ''}`}>
              {iconos[i]}
            </div>
            {i < estados.length - 1 && (
              <div className={`line ${i < index ? 'active' : ''}`}></div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="guardia-page">
      <h2>Servicios en Corral Puerta 67</h2>
      <div className="grid-servicios">
        {serviciosCorral.map((servicio) => (
          <div className="servicio-card" key={servicio.noServicio}>
            <div className="card-header">
              <span className="tipo-servicio">{servicio.tipoService}</span>
              <span className="no-servicio">No. {servicio.noServicio}</span>
            </div>
            {renderStatusProgress(servicio.statusServicio)}
            <div className="card-body">
              <div className="pax-nombre"><strong>PAX:</strong> {servicio.nombrePax}</div>
              <div className="vuelo-info">
                {servicio.aerolinea} {servicio.noVuelo}
              </div>
              <div className="info-extra">
                <span><strong>Asiento:</strong> {servicio.noAsiento}</span>
                <span><strong>Estación:</strong> {servicio.estacion}</span>
                <span><strong>Hora Inicio:</strong> {moment(servicio.horaInicio).format('HH:mm')}</span>
              </div>
              <button
                className="btn-checkpoint"
                onClick={() => handleActualizarCheckpoint(servicio)}
              >
                {servicio.tipoService === 'LLEGADAS' ? 'Asignar Servicio' : 'Asignar Servicio'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GuardiaPage;
